// extracted by mini-css-extract-plugin
var _1 = "Solution__bottom--PpBOx ProblemGeneral__bottom--ORYse";
var _2 = "Solution__engineBg--EOdE6 TrainerGeneral__engineBg--pzNDN CoreGeneral__engineBg--j2tiG";
var _3 = "Solution__inner--xKyQs";
var _4 = "Solution__left--VvaV2 ProblemGeneral__left--azXxt";
var _5 = "Solution__main--OPPBx TrainerGeneral__engineOuter--vJslo CoreGeneral__engineOuter--jw7Df";
var _6 = "Solution__narrow--VJz7c";
var _7 = "Solution__outer--t2SFo";
var _8 = "Solution__problemButton--lJysL";
var _9 = "Solution__right--baT1d ProblemGeneral__right--lXqU2";
var _a = "Solution__title--EMDLs ProblemGeneral__title--ZRR_t TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _b = "Solution__top--LJld5 ProblemGeneral__top--ODmXk";
export { _1 as "bottom", _2 as "engineBg", _3 as "inner", _4 as "left", _5 as "main", _6 as "narrow", _7 as "outer", _8 as "problemButton", _9 as "right", _a as "title", _b as "top" }
